import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

class Review extends BridgeComponent {
    static component = "review-prompt";

    prompt(event) {
        event.stopImmediatePropagation();
        event.preventDefault();
        this.#promptForReview();
    }

    #promptForReview() {
        this.send("prompt");
    }
}
export default Review;
